(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  window.location.href = "/";

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accessory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gs-accessory-product')) {
    customElements.define('gs-accessory-product', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        const form = this.querySelector('form');
        if (!form) return;
        const variant = form.querySelector('[data-accessory-variant]');
        variant?.addEventListener('change', () => {
          const option = variant.selectedOptions[0];
          this.querySelector('[data-accessory-price]').textContent = option.dataset.price;
          const compare = this.querySelector('[data-accessory-compare]');
          compare.textContent = option.dataset.compare || '';
          compare.hidden = !option.dataset.compare;
        });
        form.addEventListener('submit', async event => {
          const api = window.GutSuppCartGifts;
          if (!api?.run) return;
          event.preventDefault();
          if (this.busy) return;
          const button = form.querySelector('button[type="submit"]');
          const error = this.querySelector('[data-accessory-error]');
          const cartLink = this.querySelector('[data-accessory-cart]');
          const root = window.Shopify?.routes?.root || '/';
          const body = new FormData(form);
          body.set('sections', 'cart-aside');
          let added = false;
          let rejected = false;
          this.busy = true;
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          error.hidden = true;
          cartLink.hidden = true;
          document.dispatchEvent(new CustomEvent('gutsupp:purchase-state', {detail:{busy:true}}));
          try {
            await api.run(async ({reconcile}) => {
              const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{Accept:'application/json'},body,signal:AbortSignal.timeout(15000)});
              const result = await response.json();
              if (!response.ok) {
                rejected = true;
                throw new Error(result.description || this.dataset.error);
              }
              added = true;
              const cart = await reconcile({sections:true});
              const detail = {response:cart,handled:false,open:true};
              document.dispatchEvent(new CustomEvent('gutsupp:open-cart', {detail}));
              if (!detail.handled) window.location.assign(root + 'cart');
            });
          } catch (failure) {
            error.textContent = added ? this.dataset.addedError : rejected ? failure.message || this.dataset.error : this.dataset.unknownError;
            error.hidden = false;
            cartLink.hidden = rejected;
          } finally {
            this.busy = false;
            button.disabled = false;
            button.removeAttribute('aria-busy');
            document.dispatchEvent(new CustomEvent('gutsupp:purchase-state', {detail:{busy:false}}));
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
